import React from "react";

import { useHistory } from "react-router-dom";

import Register from "../../../../../presentation/pages/register-account/register";

import { useAuthContext } from "../../../../contexts/auth";

const MakeRegister: React.FC = () => {
  const history = useHistory();

  const authContext = useAuthContext();

  const [errorMessage, setErrorMessage] = React.useState<string | null>("");

  const handleSubmit = async (values: any): Promise<void> => {
    const { email, password, confirmPassword } = values;

    try {
      const userSignUp = await authContext.signUp({
        email,
        password,
        confirmPassword,
      });

      if (userSignUp && userSignUp.id) {
        history.push("/confirmacao-de-email");
      }
    } catch (error: any) {
      setErrorMessage(error?.message);
    }
  };

  const dataForm = [
    {
      items: [
        {
          component: "Input",
          name: "email",
          title: "E-mail",
          label: "E-mail",
          validations: "inputRequired",
        },
        {
          component: "InputPassword",
          type: "password",
          name: "password",
          title: "Senha",
          label: "Senha",
          validations: "passwordWithMatches",
        },
        {
          component: "InputPassword",
          type: "password",
          name: "confirmPassword",
          title: "Confirmar senha",
          label: "Confirmar senha",
          validations: "confirmPassword",
        },
        {
          name: "button",
          component: "Button",
          title: "Cadastrar",
          submittingText: "Cadastrando...",
        },
      ],
    },
  ];

  const props = {
    onSubmit: handleSubmit,
    dataForm,
    errorMessage,
  };

  return <Register {...props} />;
};

export default MakeRegister;
